
    import I18n from 'i18nObj';
    
      import 'translations/usage_rights_modal';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('usage_rights_modal');
  